<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="575px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        block
        color="success" 
        v-on="on"
      >
        Create Office Location
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Office Location"
      text="Create Office Location"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete 
                v-model="company"
                v-validate="'required'"
                label="Company"
                :items="companies"
                item-text="name"  
                item-value="id"
                :error-messages="errors.collect('company')"
                data-vv-name="company"     
              />  
            </v-col>

            <v-col
              cols="12" 
              class="py-0"
            >
              <v-autocomplete 
                v-model="branch"
                label="Branch"
                :items="filteredBranch"
                item-text="branch_name"
                item-value="branch_uid"  
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <i style="color:red">*Please mark the location on the map below</i>
            </v-col>
            <v-col
              v-if="gpsEnabled"
              cols="12"
              class="py-0"
            >
              <GmapMap
                :center="location"
                :zoom="15"
                map-type-id="roadmap"
                style="width: 500px; height: 300px"
                :options="{
                  zoomControl: false,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUI: false
                }"
              >
                <GmapMarker
                  :position="location"
                  :clickable="true"
                  :draggable="true"
                  @dragend="getCoordinates($event.latLng)"
                />
              </GmapMap> 
            </v-col>
            <v-col
              v-else
              cols="12"
            >
              Please Enable Location Tracking
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,
        progressing: false,
        name: null,
        latitude: null,
        longitude: null,

        defaultLatitude: 0,
        defaultLongitude: 0,
        gpsEnabled: false,

        company: null,
        branch: null,
        companies: [],
        branches: [],
      }
    },
    computed: {
      location () {
        if (!this.defaultLatitude || !this.defaultLongitude) return 

        return {
          lat: this.defaultLatitude,
          lng: this.defaultLongitude,
        }
      },

      filteredBranch () {
        if (!this.company) return this.branches
        return this.branches.filter(branch => { return branch.company_uid === this.company })
      },
    
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.resetForm()
        this.loadCompanies()
        this.loadBranches()
        this.getLocationGPS()
      },
    },
    methods: { 
      loadCompanies () {
        this.$api.companies().list()
          .then(res => {
            this.companies = res.data
          })
      },
      loadBranches () {
        this.$api.branches().list()
          .then(res => {
            this.branches = res.data
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.$api.officeLocations().create(this.prepareFormData())
              .then(response => {
                if (response.status === 201) {
                  this.$emit('created')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
   
      getCoordinates (location) {
        this.latitude = location.lat()
        this.longitude = location.lng()
      },

      prepareFormData () {
        return {
          name: this.name,
          latitude: this.latitude,
          longitude: this.longitude,
          branch_uid: this.branch,
          company_uid: this.company,
        }
      },
      getLocationGPS () {
        if (navigator.geolocation) {
          let _this = this
          navigator.geolocation.getCurrentPosition(function (position) {
            _this.latitude = position.coords.latitude
            _this.longitude = position.coords.longitude

            _this.defaultLatitude = position.coords.latitude
            _this.defaultLongitude = position.coords.longitude

            _this.gpsEnabled = true
          })
        }
      
        this.gpsEnabled = false
      },

      resetForm () {
        this.$validator.reset()
        this.name = null
        this.latitude = null
        this.longitude = null
      },
    },
  }
</script>
